import { EditProfile } from 'features/editProfile/EditProfile';

export const EditProfilePage = (): JSX.Element => (
    <>
        <EditProfile />
    </>
);
